import React, { Component } from "react";
import {
  VictoryBar,
  VictoryPie,
  VictoryChart,
  VictoryAxis,
  VictoryTheme,
  VictoryTooltip,
} from "victory";
import moment from "moment";
import { getBirthDayList, getDashboardData } from "../../actions/UserAction";
import { getDashboardLinks } from "../../actions/MasterAction";
import { Link } from "react-router-dom";
import constant from "../../constant";
import { getCookie } from "../../utils";
import CONSTANT from "./../../constant";


class FileStatsDashboard extends Component {
  constructor(props) {
    super(props);
    const userDetail = getCookie(constant.cookie.userDetail);
    this.state = {
      stats: {
        totalCreated: 0,
        totalPending: 0,
        totalSent: 0,
        totalClosed: 0,
      },
      loading: true,
      timeRange: "overall",
      userDetail: userDetail,
      b_list: undefined,
      dashboardLinks: undefined,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchDashboardData();
    this.fetchBirthDayList();
    this.fetchDashboardLinks();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchDashboardData = async () => {
    try {
      this.setState({ loading: false });

      const data = await getDashboardData(
        this.state.timeRange,
        this.state?.userDetail?.code
      );

      if (!this._isMounted) return;

      if (data?.result?.stats) {
        const stats = {
          totalCreated: Number(data.result.stats.totalCreated) || 0,
          totalPending: Number(data.result.stats.totalPending) || 0,
          totalSent: Number(data.result.stats.totalSent) || 0,
          totalClosed: Number(data.result.stats.totalClosed) || 0,
        };

        this.setState({
          stats,
          loading: false,
        });
      } else {
        this.setState({
          stats: {
            totalCreated: 0,
            totalPending: 0,
            totalSent: 0,
            totalClosed: 0,
          },
          loading: false,
        });
      }
    } catch (error) {
      if (!this._isMounted) return;

      console.error("Error fetching dashboard data:", error);

      this.setState({
        stats: {
          totalCreated: 0,
          totalPending: 0,
          totalSent: 0,
          totalClosed: 0,
        },
        loading: false,
      });
    }
  };

  fetchBirthDayList = async () => {
    getBirthDayList()
      .then((res) => {
        this.setState({ b_list: res.result });
      })
      .catch((error) => {
        console.error("Error fetching birthday list:", error);
      });
  };

  fetchDashboardLinks = async () => {
    getDashboardLinks()
      .then((res) => {
        this.setState({ dashboardLinks: res?.result || [] });
      })
      .catch((error) => {
        console.error("Error fetching dashboard links:", error);
        this.setState({ dashboardLinks: [] });
      });
  };

  handleTimeRangeChange = (event) => {
    this.setState({ timeRange: event.target.value}, () => {
      this.fetchDashboardData();
    });
  };

  getTimeRangeLabel = () => {
    const labels = {
      today: "Today",
      last7days: "Last 7 Days",
      last30days: "Last 30 Days",
      overall: "Overall",
    };
    return labels[this.state.timeRange] || "Today";
  };

  render() {
    const { stats, loading, timeRange } = this.state;

    console.log("Current render - stats:", stats);
    console.log("Current render - loading:", loading);

    // Show loading only on initial load
    if (loading) {
      return (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading E-Office Dashboard...</p>
        </div>
      );
    }

    // Bar chart data
    const barData = [
      { x: "Created", y: stats.totalCreated || 0, fill: "#4a91e2c4" },
      { x: "Pending", y: stats.totalPending || 0, fill: "#f5a523d2" },
      { x: "Sent", y: stats.totalSent || 0, fill: "#7dd321cf" },
      { x: "Closed", y: stats.totalClosed || 0, fill: "#fe1313c4" },
    ];

    // Pie chart data
    const pieData = [
      { x: "Created", y: stats.totalCreated || 0 },
      { x: "Pending", y: stats.totalPending || 0 },
      { x: "Sent", y: stats.totalSent || 0 },
      { x: "Closed", y: stats.totalClosed || 0 },
    ];

    // Summary cards
    const summaryCards = [
      {
        title: "Total Created",
        value: stats.totalCreated || 0,
        icon: "/images/totalcreated.png",
        color: "#024b9fff",
        description: "Files created by you",
        url: CONSTANT.component.myFiles.url,
      },
      {
        title: "Pending Files",
        value: stats.totalPending || 0,
        icon: "/images/pendingfiles.png",
        color: "#F5A623",
        description: "Files pending action",
        url: CONSTANT.component.inbox.url,
      },
      {
        title: "Sent Files",
        value: stats.totalSent || 0,
        icon: "/images/sendfile.png",
        color: "#7ED321",
        description: "Files sent to others",
        url: CONSTANT.component.outbox.url,
      },
      {
        title: "Closed Files",
        value: stats.totalClosed || 0,
        icon: "/images/closefile.png",
        color: "#fe1313ff",
        description: "Files closed/parked",
        url: CONSTANT.component.userParkedFileList.url,
      },
    ];


    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="eoffice-dashboard">
          <div class="card homedob p-4 mb-4">
            <div className="flex justify-content-between items-center flex-wrap pb-4">
              <div className="header-left">
                <h1>E-Office Dashboard</h1>
                <p className="time-range-label">
                  Showing data for: <strong>{this.getTimeRangeLabel()}</strong>
                </p>
              </div>
              <div className="header-right">
                <div className="time-filter">
                  <label htmlFor="timeRange">Filter by:</label>
                  <select
                    id="timeRange"
                    value={timeRange}
                    onChange={this.handleTimeRangeChange}
                    className="time-selector"
                  >
                    <option value="today">Today</option>
                    <option value="last7days">Last 7 Days</option>
                    <option value="last30days">Last 30 Days</option>
                    <option value="overall">Overall</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">

                <div className="row birthday-container">
       
        <div className="col-md-4 header-section">            
            <div className="header-content">
                <h1>🌟 TODAY'S BIRTHDAYS 🌟</h1>
                <p className="header-subtitle">Celebrating Special People on Their Special Day!</p>
            </div>
        </div>
        
       
        <div className="col-md-8 marquee-section">
            <div className="marquee-content">
                    
                
                {this.state.b_list !== undefined ? (
                    this.state.b_list.length !== 0 ? (
                <div className="birthday-card">
                  {this.state.b_list.map((ele, index) => (
                          <div className="flex" key={index}>
                    <div className="birthday-icon">
                      <div className="date-badge">
                                  <span className="date-day">
                                    {moment().format("D").toUpperCase()}
                                  </span>
                                  <span className="date-month">
                                    {moment().format("MMM").toUpperCase()}
                                  </span>
                                </div>
                    </div>
                    <div className="birthday-info">
                        <h3>{ele?.name}</h3>
                        {/* <p>May this year bring amazing opportunities!</p> */}
                        <span className="birthday-badge">🎊 Happy Birthday!</span>
                    </div>
                    </div>
                    ))}
                </div>
                ) : (
                      <div className="bobscroll d-flex justify-content-center align-items-center ">
                        <h2 className="no-birthdays-message p-3 infonewlinkdob">
                          Today there are no birthdays
                        </h2>
                      </div>
                    )
                  ) : null}
                
            </div>
        </div>
    </div>

            
              </div>
            </div>
            {/* Header with Time Filter */}
            
            <div class="row pt-3" style={{alignItems: "stretch"}}>
              <div class="col-md-6" style={{display: "flex", flexDirection: "column"}}>
                {/* Summary Cards Grid */}
                    <div className="summary-grid">
                      {summaryCards.map((card, index) => (
                        <Link
                          key={index}
                          to={card.url}
                          className="summary-card text-decoration-none"
                        >
                          <div className="card-icon">
                            <img src={card.icon} alt={card.title} />
                          </div>

                          <div className="card-content">
                            <div className="card-title">{card.title}</div>
                            <div className="card-value">{card.value}</div>
                            <div className="card-description">{card.description}</div>
                          </div>
                        </Link>
                      ))}
                    </div>
              </div>
              <div className="col-md-6" style={{display: "flex", flexDirection: "column"}}>
                <div className="card homedob bg p-3" style={{height: "420px", overflow: "hidden", display: "flex", flexDirection: "column"}}>
                  {this.state.dashboardLinks === undefined ? (
                    <div className="d-flex justify-content-center align-items-center" style={{flex: 1}}>
                      <span className="text-muted">Loading documents...</span>
                    </div>
                  ) : this.state.dashboardLinks.length === 0 ? (
                    <div className="d-flex justify-content-center align-items-center" style={{flex: 1}}>
                      <span className="text-muted">No documents available.</span>
                    </div>
                  ) : (
                    <ul className="mb-0" style={{flex: 1, overflowY: "auto", paddingRight: "4px"}}>
                      {this.state.dashboardLinks.map((link, index) => {
                        const serverBase = process.env.REACT_APP_BASE_URL.replace("v1/", "");
                        const fullUrl = link.fileUrl.startsWith("http") ? link.fileUrl : `${serverBase.replace(/\/$/, "")}${link.fileUrl}`;
                        return (
                        <li key={link.id || index}>
                          <span className="infonewlink">{link.title}</span>
                          <a
                            className="text-blue-800 text-sm"
                            href={fullUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View or Download <i className="fa fa-arrow-circle-o-down download-arrow" aria-hidden="true"></i>
                          </a>
                        </li>
                        );
                      })}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            {/* Charts Section */}
            <div className="charts-section">
              {/* Bar Chart */}
              <div className="chart-container">
                <div className="chart-header">
                  <h3>File Status Comparison</h3>
                  <span className="chart-subtitle">
                    Count of files by status
                  </span>
                </div>
                <div className="chart-body">
                  <VictoryChart
                    theme={VictoryTheme.material}
                    domainPadding={20}
                    height={200}
                  >
                    <VictoryAxis
                      tickValues={[1, 2, 3, 4]}
                      tickFormat={["Created", "Pending", "Sent", "Closed"]}
                    />
                    <VictoryAxis dependentAxis tickFormat={(x) => `${x}`} />
                    <VictoryBar
                      data={barData}
                      style={{
                        data: { fill: ({ datum }) => datum.fill },
                      }}
                      labels={({ datum }) => `${datum.x}: ${datum.y} files`}
                      labelComponent={<VictoryTooltip />}
                    />
                  </VictoryChart>
                </div>
              </div>

              {/* Pie Chart */}
              <div className="chart-container">
                <div className="chart-header">
                  <h3>File Distribution</h3>
                  <span className="chart-subtitle">
                    Percentage wise breakdown
                  </span>
                </div>
                <div className="chart-body">
                  <VictoryPie
                    data={pieData}
                    colorScale={["#0057baa1", "#f5a523aa", "#7dd321a3", "#fe1313a3"]}
                    height={250}
                    labels={({ datum }) => `${datum.x}: ${datum.y} files`}
                    labelComponent={<VictoryTooltip />}
                    labelRadius={70}
                  />
                </div>
              </div>
            </div>

            {/* Statistics Summary - Optional */}
            <div className="stats-summary pb-5">
              <div className="stats-card">
                <h4>Total Files Handled</h4>
                <div class="d-flex align-items-center justify-content-center gap-3 my-3">
                    <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title bg-secondary-subtle text-secondary rounded-circle fs-22">
                            <i class="fa fa-folder-open"></i>
                        </span>
                    </div>
                    <h3 class="mb-0 fw-bold fr-2 pb-2">
                      <span>
                        {(stats.totalCreated || 0) +
                        (stats.totalPending || 0) +
                        (stats.totalSent || 0) +
                        (stats.totalClosed || 0)}
                    </span>
                    </h3>
                </div>
                <p>All files in the system</p>
              </div>
              <div className="stats-card">
                <h4>Completion Rate</h4>
                <div class="d-flex align-items-center justify-content-center gap-3 my-3">
                    <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title bg-secondary-subtle text-secondary rounded-circle fs-22">
                            <i class="fa fa-bullseye"></i>
                        </span>
                    </div>
                    <h3 class="mb-0 fw-bold fr-2 pb-2"><span>{stats.totalCreated > 0
                    ? `${(
                        (stats.totalClosed / stats.totalCreated) *
                        100
                      ).toFixed(1)}%`
                    : "0%"}</span></h3>
                </div>
                <p>Closed vs Created files</p>
              </div>
              <div className="stats-card">
                <h4>Average Daily Files</h4>
                <div class="d-flex align-items-center justify-content-center gap-3 my-3">
                    <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title bg-secondary-subtle text-secondary rounded-circle fs-22">
                            <i class="fa fa-line-chart"></i>
                        </span>
                    </div>
                    <h3 class="mb-0 fw-bold fr-2 pb-2"><span>
                      {timeRange === "today"
                    ? stats.totalCreated || 0
                    : timeRange === "last7days"
                    ? Math.round((stats.totalCreated || 0) / 7)
                    : timeRange === "last30days"
                    ? Math.round((stats.totalCreated || 0) / 30)
                    : Math.round((stats.totalCreated || 0) / 365)}
                    </span></h3>
                </div>
                <p>Based on selected period</p>
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FileStatsDashboard;
